import React, {useState} from 'react'
import {Modal} from "antd";
import {api} from 'api/loginRoutes';
import {IVR_REMOVE_API} from "../../const";


export default (
    {
        isModalRemoveVisible,
        currentIvr,
        onCancel,
        onSuccess,
    }
) => {

    const [loading, setLoading] = useState(false);

    const handleRemove = () => {
        if (!currentIvr) {
            return;
        }

        setLoading(true);
        api(IVR_REMOVE_API, {target: {ivr_id: currentIvr.id}})
            .then(r => {
                onCancel();
                onSuccess();
            })
            .finally(() => {
                setLoading(false);
            });
    }


    return (
        <Modal
            title={`Remove IVR ${currentIvr?.name}`}
            visible={isModalRemoveVisible}
            confirmLoading={loading}
            onOk={handleRemove}
            onCancel={onCancel}
        >
            <p>Are you sure?</p>
        </Modal>
    );
};